export const GLOBAL = {
  audioCtx : new (window.AudioContext || window.webkitAudioContext) (),
  rtcPeer: undefined,
  skyWayPeer: undefined,
  dataConnection: undefined,
  mediaConnection: undefined,
  RTPStatInstance: undefined,
  RTPStatistics: [],

  localVideoTrack: [],
  localAudioTrack: [],
  sendingStream: new MediaStream(),

  remoteVideoTrack: [],
  remoteAudioTrack: [],
  receivingStream: new MediaStream(),

  filePlayer: undefined,
  audioPlayer: [],
  txVideoRecorder: undefined,

  peerDefaultConfig: {
    iceServers: [{
      urls: "stun:stun.webrtc.ecl.ntt.com:3478",
      url: "stun:stun.webrtc.ecl.ntt.com:3478",},],
    iceTransportPolicy: "all",
    sdpSemantics: "unified-plan",
  },
  defaultAudioConstraints : {
    deviceId: undefined,
    autoGainControl: false,
    noiseSuppression: false,
    echoCancellation: false,
    latency: {ideal: 0.0}
  },
  defaultVideoConstraints : {
    deviceId: undefined,
    width: {ideal: 1920}, 
    height: {ideal: 1080}
  },
  meterPeakHold: -60,
  inputAudioEffects: undefined,
};
